import { observer } from 'mobx-react-lite'
import { DownloadImage } from 'blaze-ui/icons/36/DownloadImage'
import { Action, ActionProps } from './Action'
import { useExportToZip } from 'components/ExportModal/hooks/useExportToZip'
import { ArticleFlat } from 'types'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Download } from 'blaze-ui/icons'

export const DownloadPostMediaOnly = observer(({ ...props }: ActionProps & { article: ArticleFlat }) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { exportToZip } = useExportToZip(props.article.id)

  const handleClick = () => {
    exportToZip({ mediaOnly: true })
  }

  return <Action icon={isSystemRedesignEnabled ? Download : DownloadImage} onPress={handleClick} {...props} />
})
